import { ObjetKStatus, enumValue } from '@siclop/kstone-vue'
import { ComponentCategory } from '../enums'

/**
 * Master component in the wireframe library
 */
export class WireframeComponent extends ObjetKStatus {
  designSystemId: number = 0
  code: string = ''
  name: string = ''
  category: ComponentCategory = ComponentCategory.Form
  icon?: string
  definitionJson: string = '{}'
  propertiesSchemaJson: string = '{}'
  defaultPropertiesJson: string = '{}'
  thumbnail?: string
  defaultWidth: number = 100
  defaultHeight: number = 40
  order: number = 0
  version: number = 1
  isActive: boolean = true
  isSystem: boolean = false

  constructor(data?: Partial<WireframeComponent>) {
    super(data)
    if (data) {
      this.designSystemId = data.designSystemId ?? 0
      this.code = data.code ?? ''
      this.name = data.name ?? ''
      // L'API envoie le nom (« Form ») ; les tables de libellés et les regroupements sont indexés par valeur
      this.category = enumValue(ComponentCategory, data.category, ComponentCategory.Form)
      this.icon = data.icon
      this.definitionJson = data.definitionJson ?? '{}'
      this.propertiesSchemaJson = data.propertiesSchemaJson ?? '{}'
      this.defaultPropertiesJson = data.defaultPropertiesJson ?? '{}'
      this.thumbnail = data.thumbnail
      this.defaultWidth = data.defaultWidth ?? 100
      this.defaultHeight = data.defaultHeight ?? 40
      this.order = data.order ?? 0
      this.version = data.version ?? 1
      this.isActive = data.isActive ?? true
      this.isSystem = data.isSystem ?? false
    }
  }

  /**
   * Parse component definition
   */
  get definition(): Record<string, unknown> {
    try {
      return JSON.parse(this.definitionJson)
    } catch {
      return {}
    }
  }

  /**
   * Parse properties schema
   */
  get propertiesSchema(): Record<string, unknown> {
    try {
      return JSON.parse(this.propertiesSchemaJson)
    } catch {
      return {}
    }
  }

  /**
   * Parse default properties
   */
  get defaultProperties(): Record<string, unknown> {
    try {
      return JSON.parse(this.defaultPropertiesJson)
    } catch {
      return {}
    }
  }
}
